import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { createQueryKeySet } from '~/utils/query-keys';

export type UseRecordListQueryParams = Exclude<Parameters<typeof SSF.api.resultsRecordsList>[0], undefined>;

export const keys = createQueryKeySet<UseRecordListQueryParams>('records');

export function useRecordListQuery(params: UseRecordListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.resultsRecordsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
